"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallbackRef } from "@opensea/ui-kit/hooks";
import { createContext, useContext } from "react";
const CollectionLayoutContext = createContext({
  avatarRef: null,
  setAvatarRef: () => undefined,
  isPreview: false
});
export function CollectionLayoutProvider(t0) {
  const $ = _c(7);
  const {
    children,
    isPreview: t1
  } = t0;
  const isPreview = t1 === undefined ? false : t1;
  const [avatarRef, setAvatarRef] = useCallbackRef();
  let t2;
  if ($[0] !== avatarRef || $[1] !== isPreview || $[2] !== setAvatarRef) {
    t2 = {
      avatarRef,
      setAvatarRef,
      isPreview
    };
    $[0] = avatarRef;
    $[1] = isPreview;
    $[2] = setAvatarRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const value = t2;
  let t3;
  if ($[4] !== children || $[5] !== value) {
    t3 = <CollectionLayoutContext.Provider value={value}>{children}</CollectionLayoutContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function useCollectionLayout() {
  return useContext(CollectionLayoutContext);
}